import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { captureAdsClick, ensureGtag } from '../../utils/googleAds';

/**
 * Keeps the Google Ads click (gclid, or gbraid/wbraid on iOS) from any
 * storefront URL for 90 days with the store it landed on, and loads gtag
 * when this company has Google Ads conversion tracking enabled.
 */
const GoogleAdsTracker = () => {
  const location = useLocation();
  const googleAds = useSelector(
    (state) => state.base.common.currentStore?.googleAds,
  );

  useEffect(() => {
    captureAdsClick(location.search, location.pathname);
  }, [location.search, location.pathname]);

  useEffect(() => {
    if (googleAds?.enabled && googleAds.conversionId) {
      ensureGtag(googleAds.conversionId);
    }
  }, [googleAds?.enabled, googleAds?.conversionId]);

  return null;
};

export default GoogleAdsTracker;
